var Subscribable=class{subscribe(listener){this.listeners.add(listener);this.onSubscribe();return ()=>{this.listeners.delete(listener);this.onUnsubscribe();}}hasListeners(){return this.listeners.size>0}onSubscribe(){}onUnsubscribe(){}constructor(){this.listeners=new Set;this.subscribe=this.subscribe.bind(this);}};

export { Subscribable };
//# sourceMappingURL=subscribable.js.map
